//
// # App
//
// The top-level React component for the IDE.
// Wraps the layout in a WorkspaceProvider so all
// descendant components can access the Workspace.
//

import React from "react";
import { WorkspaceProvider } from "./context";
import { WorkspaceLayout } from "./WorkspaceLayout";
import { Workspace } from "./workspace";

export interface AppProps {
  workspace: Workspace;
}

export function App({ workspace }: AppProps) {
  return (
    <WorkspaceProvider workspace={workspace}>
      <WorkspaceLayout />
    </WorkspaceProvider>
  );
}
